import getWebShellClientLocale from "../utils/get-webshellclient-locale";

/**
 * @description Basic feature flag for global store geos that use fulfillment offerings and partner cart reviews v2. Keeping it simple for now.
 * @returns {boolean} - true if the current country is a global store geos enabled country, false otherwise
 */
var determineGlobalStoreFoffsEnabled = function determineGlobalStoreFoffsEnabled() {
  var _getWebShellClientLoc = getWebShellClientLocale(),
    country = _getWebShellClientLoc.country;
  if (country === 'mx') {
    return true;
  }
  return false;
};
export default determineGlobalStoreFoffsEnabled;